var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPosition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    x: 0,
    y: 0,
    viewBox: "0 0 2048 2048",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#e67528",
    d: "M1883.23 1227.33v154.01c0 15.2-8.44 29.14-21.89 36.19l-3.65 1.91-161.76 84.78h-170.51v-32.18h-95.31v32.18H1259.6l-161.77-84.78-3.64-1.91a40.856 40.856 0 0 1-21.88-36.19v-154.01c0-22.57 18.29-40.86 40.85-40.86h729.21c22.57 0 40.86 18.29 40.86 40.86z",
    opacity: 1,
    "data-original": "#e67528"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff8938",
    d: "M1857.69 1419.44v281.68c0 22.56-18.29 40.85-40.85 40.85h-678.15c-22.56 0-40.86-18.29-40.86-40.85v-281.68l161.77 84.78h170.51v32.18l47.65 40.85 47.66-40.85v-32.18h170.51z",
    opacity: 1,
    "data-original": "#ff8938",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffde75",
    d: "M1525.42 1504.22v32.18l-47.66 40.85-47.65-40.85v-64.36h95.31z",
    opacity: 1,
    "data-original": "#ffde75"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e67528",
    d: "M950.16 621.91 788.4 706.68H617.89v-32.17h-95.31v32.17H352.07L190.3 621.91v-.01l-3.64-1.9a40.877 40.877 0 0 1-21.89-36.19V429.8c0-22.57 18.29-40.86 40.86-40.86h729.21c22.56 0 40.85 18.29 40.85 40.86v154.01c0 15.2-8.43 29.13-21.88 36.19z",
    opacity: 1,
    "data-original": "#e67528"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff8938",
    d: "M950.16 621.91v281.68c0 22.56-18.29 40.85-40.85 40.85H231.15c-22.56 0-40.85-18.29-40.85-40.85V621.91l161.77 84.77h170.51v32.18l47.65 40.86 47.66-40.86v-32.18H788.4z",
    opacity: 1,
    "data-original": "#ff8938",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffde75",
    d: "M617.89 706.68v32.18l-47.66 40.86-47.65-40.86v-64.35h95.31z",
    opacity: 1,
    "data-original": "#ffde75"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M1453 1000.26c-13.25 0-24-10.75-24-24V637.33h-338.92c-13.25 0-24-10.75-24-24s10.75-24 24-24H1453c13.25 0 24 10.75 24 24v362.92c0 13.26-10.74 24.01-24 24.01zM953.1 1452.12H590.18c-13.25 0-24-10.75-24-24V1065.2c0-13.25 10.75-24 24-24s24 10.75 24 24v338.92H953.1c13.25 0 24 10.75 24 24s-10.74 24-24 24z",
    opacity: 1,
    "data-original": "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M1453 1000.26c-6.14 0-12.28-2.34-16.97-7.03l-88.17-88.17c-9.37-9.37-9.37-24.57 0-33.94s24.57-9.37 33.94 0l71.2 71.2 71.2-71.2c9.37-9.37 24.57-9.37 33.94 0s9.37 24.57 0 33.94l-88.17 88.17a23.926 23.926 0 0 1-16.97 7.03zM678.36 1177.37c-6.14 0-12.28-2.34-16.97-7.03l-71.2-71.2-71.2 71.2c-9.37 9.37-24.57 9.37-33.94 0s-9.37-24.57 0-33.94l88.17-88.17c9.37-9.37 24.57-9.37 33.94 0l88.17 88.17c9.37 9.37 9.37 24.57 0 33.94a23.919 23.919 0 0 1-16.97 7.03zM909.31 968.44H231.15c-35.76 0-64.85-29.09-64.85-64.85V621.9c0-13.25 10.75-24 24-24s24 10.75 24 24v281.68c0 9.29 7.56 16.85 16.85 16.85H909.3c9.29 0 16.85-7.56 16.85-16.85V621.9c0-13.25 10.75-24 24-24s24 10.75 24 24v281.68c.01 35.77-29.08 64.86-64.84 64.86zM677.9 412.94H462.56c-13.25 0-24-10.75-24-24v-22.92c0-46.32 37.68-84 84-84h95.34c46.32 0 84 37.68 84 84v22.92c0 13.26-10.74 24-24 24zm-191.32-48h167.31c-.57-19.35-16.5-34.92-35.98-34.92h-95.34c-19.5.01-35.42 15.57-35.99 34.92z",
    opacity: 1,
    "data-original": "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M788.4 730.68H617.89c-13.25 0-24-10.75-24-24s10.75-24 24-24h164.6l160.18-83.94c5.57-2.92 9.03-8.64 9.03-14.93V429.8c0-9.29-7.56-16.85-16.85-16.85H205.63c-9.29 0-16.85 7.56-16.85 16.85v154.02c0 6.29 3.46 12.01 9.03 14.93l160.17 83.94h164.6c13.25 0 24 10.75 24 24s-10.75 24-24 24H352.07c-3.88 0-7.7-.94-11.14-2.74l-165.41-86.69c-21.43-11.23-34.75-33.24-34.75-57.44V429.8c0-35.76 29.09-64.85 64.85-64.85h729.21c35.76 0 64.85 29.09 64.85 64.85v154.02c0 24.2-13.31 46.21-34.75 57.44l-165.41 86.69a23.994 23.994 0 0 1-11.12 2.73z",
    opacity: 1,
    "data-original": "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M570.23 803.72c-5.56 0-11.13-1.93-15.62-5.78l-47.65-40.85a24.003 24.003 0 0 1-8.38-18.22v-64.36c0-13.25 10.75-24 24-24h95.31c13.25 0 24 10.75 24 24v64.36c0 7.01-3.06 13.66-8.38 18.22l-47.65 40.85a24.007 24.007 0 0 1-15.63 5.78zm-23.65-75.89 23.65 20.28 23.65-20.28v-29.32h-47.31v29.32zM1816.84 1765.97h-678.15c-35.76 0-64.85-29.09-64.85-64.85v-281.68c0-13.25 10.75-24 24-24s24 10.75 24 24v281.68c0 9.29 7.56 16.85 16.85 16.85h678.15c9.29 0 16.85-7.56 16.85-16.85v-281.68c0-13.25 10.75-24 24-24s24 10.75 24 24v281.68c0 35.76-29.09 64.85-64.85 64.85zM1585.43 1210.47h-215.34c-13.25 0-24-10.75-24-24v-22.92c0-46.32 37.68-84 84-84h95.34c46.32 0 84 37.68 84 84v22.92c0 13.26-10.74 24-24 24zm-191.32-48h167.31c-.57-19.35-16.5-34.92-35.98-34.92h-95.34c-19.49.01-35.42 15.57-35.99 34.92z",
    opacity: 1,
    "data-original": "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M1695.93 1528.22h-170.51c-13.25 0-24-10.75-24-24s10.75-24 24-24h164.6l160.18-83.95c5.57-2.92 9.03-8.64 9.03-14.93v-154.02c0-9.29-7.56-16.85-16.85-16.85h-729.21c-9.29 0-16.85 7.56-16.85 16.85v154.02c0 6.29 3.46 12.01 9.03 14.93l160.17 83.95h164.6c13.25 0 24 10.75 24 24s-10.75 24-24 24H1259.6c-3.88 0-7.7-.94-11.14-2.74l-165.41-86.69c-21.43-11.23-34.75-33.24-34.75-57.44v-154.02c0-35.76 29.09-64.85 64.85-64.85h729.21c35.76 0 64.85 29.09 64.85 64.85v154.02c0 24.2-13.32 46.21-34.75 57.44l-165.41 86.69a24.004 24.004 0 0 1-11.12 2.74z",
    opacity: 1,
    "data-original": "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M1477.76 1601.25c-5.56 0-11.13-1.93-15.62-5.78l-47.65-40.85a23.988 23.988 0 0 1-8.38-18.22v-64.36c0-13.25 10.75-24 24-24h95.31c13.25 0 24 10.75 24 24v64.36c0 7.01-3.06 13.66-8.38 18.22l-47.66 40.85a23.943 23.943 0 0 1-15.62 5.78zm-23.65-75.89 23.65 20.28 23.66-20.28v-29.32h-47.31z",
    opacity: 1,
    "data-original": "#333333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosition);
export default __webpack_public_path__ + "static/media/position.683bb880bca741a6c6d01256aba51814.svg";
export { ForwardRef as ReactComponent };